"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StolenStatsEffectHandler = exports.StolenStatsEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class StolenStatsEffectArgs {
    constructor(attributeScoreAdjustments) {
        this.attributeScoreAdjustments = attributeScoreAdjustments;
        this.__type = EffectType_1.EffectType.StolenStats;
        this.__typeName = "StolenStats";
        this.name = "Stolen Stats";
        this.harmful = false;
    }
}
exports.StolenStatsEffectArgs = StolenStatsEffectArgs;
let StolenStatsEffectHandler = class StolenStatsEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = [];
        for (const attributeScoreAdjustment of state.args.attributeScoreAdjustments) {
            state.meta.effectIds.push(container.applyBuff({
                sequence,
                creatorId: state.creatorId,
                targetId: state.targetId,
                effect: new _1.MaxAttributeIncreaseEffectArgs(attributeScoreAdjustment.attribute, attributeScoreAdjustment.adjustment),
                duration: Duration_1.Duration.Permanent,
            }));
        }
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of state.meta.effectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
StolenStatsEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.StolenStats)
], StolenStatsEffectHandler);
exports.StolenStatsEffectHandler = StolenStatsEffectHandler;
